import type { ComputedRef, InjectionKey, VNodeChild } from 'vue';

export interface InputGroupAffixContext
{
    hasPrepend: ComputedRef<boolean>;
    hasAppend: ComputedRef<boolean>;
    owner: ComputedRef<symbol | undefined>;
    prepend: () => VNodeChild;
    append: () => VNodeChild;
    claim: (owner: symbol) => () => void;
    contains: (element: HTMLElement) => boolean;
}

export const inputGroupAffixKey: InjectionKey<InputGroupAffixContext> = Symbol('input-group-affixes');
